module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Y Black.aa6be269.png";